import { gql } from '@apollo/client';

export const verifyEmailMutation = gql`
  mutation verifyEmail {
    verifyEmail {
      id
    }
  }
`;
